/**
 * Transforms nested validation errors from API response into a flat structure.
 * - Arrays are converted to their first element
 * - Nested objects are recursively transformed
 * - String values are passed through as-is
 */
const transformValidationErrors = (
  errors: Record<string, any>,
): Record<string, any> => {
  const transformed: Record<string, any> = {};

  Object.entries(errors).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      // Take first error message from array
      transformed[key] = value[0];
    } else if (typeof value === 'object' && value !== null) {
      // Recursively transform nested objects
      transformed[key] = transformValidationErrors(value);
    } else {
      // Use string value as-is
      transformed[key] = value;
    }
  });

  return transformed;
};

export default transformValidationErrors;
